var FitableSupport = require("enyo-ui/FitableSupport"),
    Image          = require("app/ui/Image"),
    frameThrottle  = require("enyo-perf/utils").frameThrottle,
    get            = require("object-path").get,
    kind           = require("enyo/kind"),
    themeVars      = require("app/theme/ImageReaderPageThumbnailVariables");

require("./PageThumbnail.less");

module.exports = kind(/** @lends  app.MediaPlayer.Tech.ImageReader.PageThumbnail.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.ImageReader.PageThumbnail",

    /**
     * @private
     */
    classes: "app-media-player-image-reader-page-thumbnail",

    /**
     * @private
     */
    mixins: [
        FitableSupport
    ],

    /**
     * The dataset
     *
     * @type {?Object}
     * @public
     */
    data: null,

    /**
     * @private
     */
    components: [{
        name:       "imageWrapper",
        classes:    "app-media-player-image-reader-page-thumbnail__image-wrapper",
        components: [{
            name:       "image",
            kind:       Image,
            classes:    "app-media-player-image-reader-page-thumbnail__image",
            attributes: {
                loading:  "eager",
                decoding: "async"
            }
        }]
    }, {
        name:    "title",
        classes: "app-media-player-image-reader-page-thumbnail__title"
    }],

    /**
     * @private
     */
    handlers: {
        ontap:         "navigate",
        oncontextmenu: "oncontextmenu"
    },

    /**
     * @private
     */
    observers: {
        update: ["data"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * Prevent context-menu from showing
     *
     * @param  {enyo.Control}  sender  The sender of the event
     * @param  {Object}   event   The event object
     * @private
     */
    oncontextmenu: function(sender, event) {
        event.preventDefault();
    },

    /**
     * Update the component in response to state changes.
     *
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            data        = this.data || {};

        this.setAttribute("title", i18nService.getString("app.MediaPlayer.ImageReader.PageThumbnail.tooltip", {
            pageNr: data.pageNr || null
        }));

        this.$.image.set("src", data.url ? data.url : null);
        this.$.title.set("content", get(data, "page", null) || "");
    },

    /**
     * Calculates the width.
     *
     * @param   {number}  height  The height
     * @return  {number}  The width.
     * @public
     */
    calcWidth: function(height) {
        var data = this.data,
            ratio;

        if (!data.width || !data.height) {
            return 0;
        }

        ratio = data.width / data.height;

        if (height === 0) {
            return 0;
        }
        else if (this.showTitle) {
            return (height - themeVars.getTitleHeightPx()) * ratio;
        }
        else {
            return height * ratio;
        }
    },

    /**
     * Calculates the height.
     *
     * @param   {number}  width  The width
     * @return  {number}  The height.
     * @public
     */
    calcHeight: function(width) {
        var data = this.data,
            ratio;

        if (!data.width || !data.height) {
            return 0;
        }

        ratio = data.width / data.height;

        if (width === 0) {
            return 0;
        }
        else if (this.showTitle) {
            return width / ratio + themeVars.getTitleHeightPx();
        }
        else {
            return width / ratio;
        }
    },

    /**
     * @private
     */
    navigate: function() {
        var index = this.repeater.getIndexByRecord(this.data);
        this.bubbleUp("onRequestPage", {
            page: index
        });
    }

});
